(function () {

    angular.module("app").factory("HabilUrlParser", HabilUrlParserFactory);

    HabilUrlParserFactory.$inject = ["$window"];
    function HabilUrlParserFactory($window) {

        return {
            Parse: parse,
            ParsePretty: parsePretty
        };

        function parse(location) {

            const normalizedLocation = getLocationIfNullOrUndefined(location);
            if (normalizedLocation === undefined)
                throw new Error('HabilUrlParser.Parse cannot resolve the browsers Location');

            const result = {
                action: '',
                actionLocation: '',
                parameters: {}
            };

            // <protocol:>//<hostname>:<port>/A/b?<GET>
            // Location.pathname is the route of the URL (/A/b)
            // Location.search is the GET search string

            // Parse the last 2 parts of the route
            const path = normalizedLocation.pathname.split('/').filter(el => el.length !== 0);
            const actionIndex = path.length - 1;
            result.action = path[actionIndex].toLowerCase();
            result.actionLocation = path[actionIndex - 1].toLowerCase();

            // Parse the parameters

            const params = new URLSearchParams(normalizedLocation.search);

            for (const [key, value] of params) {
                result.parameters[key.toLowerCase()] = encodeURIComponent(value);
            }

            return result;
        }

        function parsePretty(location) {

            const normalizedLocation = getLocationIfNullOrUndefined(location);
            if (normalizedLocation === undefined)
                throw new Error('HabilUrlParser.Parse cannot resolve the browsers Location');

            const result = {
                id: '',
                action: '',
                parameters: {}
            };

            // <protocol:>//<hostname>:<port>/A/b?<GET>
            // Location.pathname is the route of the URL (/A/b)
            // Location.search is the GET search string

            // Parse the last 2 parts of the route
            const path = normalizedLocation.pathname.split('/').filter(el => el.length !== 0);
            const actionIndex = path.length - 1;
            result.id = path[actionIndex].toLowerCase();
            result.action = path[actionIndex - 1].toLowerCase();

            // Parse the parameters

            const params = new URLSearchParams(normalizedLocation.search);

            for (const [key, value] of params) {
                result.parameters[key.toLowerCase()] = encodeURIComponent(value);
            }

            return result;
        }

        function getLocationIfNullOrUndefined(location) {

            if (location === null || location === undefined)
                return $window.location;

            if (location instanceof Location)
                return location;

            return undefined;
        }
    }
})();